import { useQuery } from "@tanstack/react-query";
import { useAxios } from "../useAxios"
import { useTranslation } from "react-i18next";

export const useCanDeleteExam = (id: string, isOpen: boolean) => {

    const axios = useAxios();
    const {t} = useTranslation();

    const canDeleteExam = async () => {
        try {
            const { data } = await axios.get(`/api/exam/CanDeleteExam/${id}`);
            return data;
        } catch (error) {
            throw new Error(t("messages.error.canDeleteExam"));
        }
    }

    return useQuery({queryKey: ["canDeleteExam", id], queryFn: canDeleteExam, enabled: !!isOpen, gcTime: 10000});

}